import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { withTheme, IWithThemeProps } from '../../theme'

import { Flex } from '../flex'

import getStyles from './styles'

interface IModalContainerProps {
  onClose: () => void
  overlays: any[]
  children: React.ReactNode
  style?: Rule
}

interface IModalContainerState {
  showWrapper: boolean
  renderWrapper: boolean
}

export class ModalContainer extends React.Component<IModalContainerProps, IModalContainerState> {
  static propTypes = {
    overlays: PropTypes.array,
    children: PropTypes.node,
    style: PropTypes.object,
  }

  state = {
    showWrapper: false,
    renderWrapper: true,
  }

  componentDidUpdate(prevProps: IModalContainerProps) {
    if (
      prevProps.overlays &&
      prevProps.overlays.length > 0 &&
      (this.props.overlays.length === 0 || !this.props.overlays)
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showWrapper: false })
      setTimeout(() => {
        if (this.props.overlays && this.props.overlays.length > 0) {
          this.showWrapper()
        } else {
          this.setState({ renderWrapper: false })
        }
      }, 500)
    } else if (
      this.props.overlays &&
      (!prevProps.overlays || this.props.overlays.length !== prevProps.overlays.length)
    ) {
      this.showWrapper()
    }
  }

  showWrapper() {
    this.setState({ renderWrapper: true })
    setTimeout(() => this.setState({ showWrapper: true }))
  }

  render() {
    const { children, overlays: modals, onClose, ...additional } = this.props

    return (
      <>
        {this.state.renderWrapper && (
          <ModalWrapper modals={modals} onClose={onClose} visible={this.state.showWrapper} {...additional} />
        )}
        {children}
      </>
    )
  }
}

interface IModalWrapperProps {
  onClose?: () => void
  modals: any[]
  visible?: boolean
  style?: Rule
  alignItems?: 'center' | 'flex-start' | 'flex-end'
}

const ModalWrapper = withTheme(
  class ModalWrapper extends React.Component<IModalWrapperProps & IWithThemeProps> {
    static propTypes = {
      onClose: PropTypes.func,
      modals: PropTypes.array.isRequired,
      visible: PropTypes.bool,
      style: PropTypes.object,
      alignItems: PropTypes.oneOf(['center', 'flex-start', 'flex-end']),
    } as any

    componentWillUnmount() {
      // When closing, put back focus on the element that caused the modal to appear
      // (or at least that had focus before it did)
      if (this.triggeringElement && this.triggeringElement.focus) {
        this.triggeringElement.focus()
      }
    }

    handleClick = () => {
      const { onClose } = this.props
      if (onClose) {
        onClose()
      }
    }

    triggeringElement = document.activeElement as HTMLAnchorElement | HTMLButtonElement | undefined

    render() {
      const { modals, visible, style, alignItems = 'flex-start' } = this.props

      const [Modal] = modals

      const styles = getStyles(this.props.theme)

      return (
        <div {...css([styles.scroller.base, visible && styles.scroller.visible, style])}>
          <Flex
            alignItems="center"
            flexDirection="row"
            justifyContent="center"
            style={{ ...styles.aligner.base, ...{ alignItems } }}
          >
            {/* shield is not enabled for keyboard navigation */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <div onClick={this.handleClick} {...css(styles.shield.base)} />
            {visible && Modal && (React.isValidElement(Modal) ? Modal : <Modal />)}
          </Flex>
        </div>
      )
    }
  }
)
